export default "__VITE_ASSET__DlkB8enX__"